"use client";
import React, { useState } from "react";
// import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import Image from "next/image";
import Link from "next/link";
// console.log(MyData, 'sssss');
import style from "@/app/style/state.module.css";

// cities page states

function discover({ Mydata }) {
  const data = Mydata[4];

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div>
      <div className=" mb-10">
        <div className="mx-auto max-w-7xl ">
          {/* Content goes here */}
          {/* ============================================================================================== */}

          <div className="mx-auto max-w-7xl px-6">
            <div className=" flex  pb-4 justify-between">
              <h2 className="text-3xl  font-bold secondary secondary">
               {data.title}
              </h2>
              {/* <div className="item  text-end">
                <a className="text-xl normal view" href="#">
                  View all
                </a>
              </div> */}
            </div>
            <div className="grid gap-3  grid-cols-1  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4   xl:gap-10 ">
              {data?.cities?.map((server, index) => {
                return (
                  // <>
                  <Link href={server.Link} onClick={scrollTop} key={index}>
                    <div
                      id={style.maincitysize}
                      className={style[server.image]}
                    >
                      <div className="    mt-1 text-white">
                        <div className="px-4  ">
                          <h2 className=" flex   justify-start items-ends updatedheading text-white">
                            {server.title}
                          </h2>
                          <p className=" text-left updatedparapremu text-white">
                            {server.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  // </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default discover